<template>
  <main id="perfil-screen" class="full-height">
    <v-content id="scroll-top-bottom">
      <v-container fluid grid-list-xl>
        <v-layout justify-center row wrap>
          <v-flex xs12>
            <form-alert
              :type="alertText.type"
              :message="alertText.message"
              @close="closeFormAlert"
            ></form-alert>
          </v-flex>

          <!--- <button-voltar :path="'/corretores'"></button-voltar> -->
          <button
            v-for="tab in tabs"
            :key="tab.path"
            class="blue-button inverted tab-button mb-4"
            v-html="tab.name"
            :class="{ active: tab.path === activeTab }"
            @click="activeTab = tab.path"
          ></button>

          <v-flex xs12 v-if="loaded && activeTab === 'dados-gerais'">
            <v-card class="form-card">
              <v-card-title>Dados Gerais</v-card-title>
              <v-layout row wrap>
                <v-flex xs3>
                  <v-text-field
                    class="form-input-box"
                    label="CNPJ"
                    placeholder=" "
                    :value="formatCNPJ(model.corretor.cnpj_cpf)"
                    :title="formatCNPJ(model.corretor.cnpj_cpf)"
                    readonly
                  ></v-text-field>
                </v-flex>

                <v-flex xs5>
                  <v-text-field
                    class="form-input-box"
                    label="Razão Social"
                    readonly
                    v-model="model.corretor.nome"
                    :title="model.corretor.nome"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    class="form-input-box"
                    readonly
                    label="Email Susep"
                    v-model="model.corretor.email"
                    :title="model.corretor.email"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-text-field
                    class="form-input-box"
                    label="Situação SUSEP"
                    readonly
                    :value="model.corretor.situacao_susep ? 'Ativo' : 'Inativo'"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>

                <v-flex xs3>
                  <p class="mb-0 pb-0 radio-label">
                    Simples Nacional
                    <v-icon
                      @click="toggleTooltip('simplesNacional')"
                      class="info-icon"
                      >info</v-icon
                    >
                    <v-tooltip
                      max-width="500"
                      v-model="simplesNacionalTooltipShow"
                      bottom
                    >
                      <v-icon slot="activator"></v-icon>
                      <span v-html="simplesNacionalTooltipText"></span>
                    </v-tooltip>
                  </p>
                  <v-radio-group
                    v-model="model.corretor.simples_nacional"
                    readonly
                    row
                    class="mb-0 pb-0 mt-1 pt-1"
                  >
                    <v-radio disabled label="Optante" :value="true"></v-radio>
                    <v-radio
                      disabled
                      label="Não-optante"
                      :value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>

                <v-flex xs2>
                  <v-text-field
                    class="form-input-box"
                    label="CEP"
                    readonly
                    :value="formatCEP(model.corretor.endereco.cep)"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    class="form-input-box"
                    readonly
                    label="Logradouro"
                    v-model="model.corretor.endereco.logradouro"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>

                <v-flex xs3>
                  <v-text-field
                    class="form-input-box"
                    label="Bairro"
                    readonly
                    v-model="model.corretor.endereco.bairro"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    class="form-input-box"
                    label="Cidade"
                    readonly
                    v-model="model.corretor.endereco.cidade"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>

                <v-flex xs3>
                  <v-text-field
                    class="form-input-box"
                    label="Estado"
                    readonly
                    v-model="model.corretor.endereco.uf"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>

                <v-flex xs3>
                  <v-text-field
                    class="form-input-box"
                    label="Telefone Empresa"
                    readonly
                    v-model="model.corretor.telefone"
                    v-the-mask="['(##) #####-####', '(##) ####-####']"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 offset-xs9 no-padding-top>
                  <button
                    class="button jns-button yellow-button no-margin-top"
                    @click="getMe(true)"
                    v-if="model.perfil === 'ADMIN_SUSEP'"
                  >
                    Atualizar Dados
                  </button>
                </v-flex>
              </v-layout>
            </v-card>
            <v-card class="form-card mt-5">
              <v-card-title>Senha</v-card-title>
              <v-layout row wrap>
                <v-flex xs4>
                  <button
                    class="jns-button yellow-button"
                    @click="updatePasswordModal = true"
                  >
                    Alterar Senha
                  </button>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 v-if="activeTab === 'dados-bancarios'">
            <v-card class="form-card">
              <v-card-title>Dados Bancários</v-card-title>

              <dados-bancarios-component
                class="component-padding"
                ref="formDadosBancariosComponent"
                :bancos="bancos"
                :dados_bancarios="model.corretor.informacao_bancaria"
                :showCpom="true"
                :readonly="model.perfil !== ADMIN_SUSEP"
              ></dados-bancarios-component>

              <v-layout row wrap>
                <v-flex xs3 offset-xs9 no-padding-top>
                  <button
                    class="button jns-button yellow-button no-margin-top"
                    @click.prevent="updateBankInformation()"
                    v-if="model.perfil === ADMIN_SUSEP"
                  >
                    Salvar
                  </button>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 v-if="activeTab === 'contatos'">
            <v-card id="container" class="form-card">
              <v-card-title>Usuários</v-card-title>

              <div class="box-button-add" v-if="checkIfIsAdmin()">
                <v-btn
                  @click="insereUsuario()"
                  class="jns-button yellow-button"
                >
                  <v-icon>add_circle_outline</v-icon
                  ><span>Adicionar mais usuários</span>
                </v-btn>
              </div>

              <v-form
                :ref="'form' + index"
                v-model="valid[index]"
                class="form-contato mt-2"
                v-for="(contato, index) in model.corretor.contatos"
                :key="index"
              >
                <div class="contact-row">
                  <div class="primeira-row">
                    <v-text-field
                      class="form-input-box"
                      label="Nome"
                      :title="contato.nome"
                      v-model="contato.nome"
                      :readonly="!hasPermission('nome', contato)"
                      placeholder=" "
                    ></v-text-field>
                    <v-text-field
                      class="form-input-box"
                      label="Telefone"
                      :title="contato.telefone"
                      placeholder=" "
                      v-model="contato.telefone"
                      :rules="[
                        (v) =>
                          (!!v && v.length > 13) ||
                          'Este número de telefone não é válido!',
                      ]"
                      :readonly="!hasPermission('nome', contato)"
                      v-the-mask="['(##) #####-####', '(##) ####-####']"
                    ></v-text-field>
                    <v-text-field
                      class="form-input-box margin-none"
                      label="Email"
                      v-model="contato.email"
                      :title="contato.email"
                      :rules="[
                        (v) =>
                          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                            v
                          ) || 'E-mail tem que ser válido',
                        (v) => {
                          return (
                            usedEmails.filter((item) => item === v).length ===
                              1 || 'E-mail já foi utilizado'
                          );
                        },
                      ]"
                      :readonly="!hasPermission('email', contato)"
                      placeholder=" "
                    ></v-text-field>
                  </div>
                  <div class="segunda-row">
                    <div class="box-select-perfil">
                      <v-select
                        class="form-select-box"
                        label="Perfil"
                        v-model="contato.perfil"
                        placeholder="Selecionar "
                        :rules="[
                          (v) => !!v || 'Este campo deve ser preenchido!',
                        ]"
                        :readonly="!hasPermission('perfil', contato)"
                        :items="
                          contato.perfil === ADMIN_SUSEP
                            ? niveisPerfis
                            : niveisPerfis.filter(
                                (item) => item.value !== ADMIN_SUSEP
                              )
                        "
                        :item-value="'value'"
                        :item-text="'name'"
                      ></v-select>
                    </div>

                    <div class="box-actions">
                      <div
                        class="box-switch"
                        v-if="
                          model.perfil !== CORRETOR &&
                            contato.perfil !== ADMIN_SUSEP &&
                            !contato.justCreated
                        "
                      >
                        <label
                          class="switch-label"
                          v-html="
                            contato.bloqueado ? 'Bloqueado' : 'Desbloqueado'
                          "
                        />
                        <v-switch
                          class="block-switch"
                          v-model="contato.bloqueado"
                          @click.native="toggleBlocked(contato)"
                          :readonly="!hasPermission('bloqueado', contato)"
                        ></v-switch>
                      </div>
                      <!-- esse div só aparece se uma das duas condições
                      do seu filho forem alimentadas-->
                      <div class="box-buttons">
                        <div
                          class="box-button"
                          v-if="
                            (model.perfil !== CORRETOR &&
                              contato.perfil !== ADMIN_SUSEP &&
                              !contato.justCreated) ||
                              (contato.email !== model.email &&
                                contato.justCreated)
                          "
                        >
                          <button
                            v-if="
                              model.perfil !== CORRETOR &&
                                contato.perfil !== ADMIN_SUSEP &&
                                !contato.justCreated
                            "
                            class="
                              button
                              jns-button
                              white-button
                              mt-3
                              margin-right
                            "
                            @click="
                              contactToDelete = contato;
                              confirmDeleteModal = true;
                            "
                            :readonly="!hasPermission('bloqueado', contato)"
                          >
                            Remover
                          </button>

                          <button
                            v-if="
                              contato.email !== model.email &&
                                contato.justCreated
                            "
                            class="
                              button
                              jns-button
                              white-button
                              mt-3
                              margin-right
                            "
                            @click.prevent="
                              removeContactOnlyFromClient(contato)
                            "
                          >
                            Remover
                          </button>
                        </div>
                        <div
                          class="box-button"
                          v-if="model.perfil !== CORRETOR"
                        >
                          <button
                            v-if="contato.hasOwnProperty('justCreated')"
                            class="
                              button
                              jns-button
                              yellow-button
                              full-width
                              mt-3
                            "
                            @click.prevent="insertContact(contato, true, index)"
                          >
                            Inserir
                          </button>
                          <button
                            v-if="
                              hasPermission('salvar', contato) &&
                                !contato.hasOwnProperty('justCreated')
                            "
                            class="
                              button
                              jns-button
                              yellow-button
                              full-width
                              mt-3
                            "
                            @click.prevent="updateContact(contato, true, index)"
                          >
                            Salvar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-form>
            </v-card>
          </v-flex>

          <v-flex xs12 v-if="activeTab === 'aceite'">
            <v-card class="form-card">
              <v-card-title>Termos de Declaração</v-card-title>

              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="tos"
                    disabled
                    textarea
                    hide-details
                    class="tos-text-field"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-dialog v-model="updatePasswordModal" :max-width="'640'">
            <atualizar-senha-modal
              :user-id="userId"
              @close="
                updatePasswordModal = false;
                $forceUpdate();
              "
            ></atualizar-senha-modal>
          </v-dialog>
          <v-dialog v-model="confirmDeleteModal" :max-width="'640'">
            <main id="selecionar-empresa" class="ohx login-modal">
              <v-content class="ohx">
                <v-container
                  fluid
                  grid-list-xs
                  class="white-background ohx pb-4"
                >
                  <v-layout row wrap>
                    <v-flex xs12>
                      <h2 class="title">Tem certeza?</h2>
                      <p class="description">
                        Essa ação não poderá ser desfeita.
                      </p>
                      <v-layout row wrap>
                        <v-flex xs4></v-flex>
                        <v-flex xs4>
                          <v-btn
                            class="button jns-button yellow-button"
                            @click="deleteContact(contactToDelete)"
                            >OK</v-btn
                          >
                        </v-flex>
                        <v-flex xs4>
                          <v-btn
                            class="button jns-button yellow-button"
                            @click="
                              confirmDeleteModal = false;
                              contactToDelete = false;
                            "
                            >Cancelar</v-btn
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-content>
            </main>
          </v-dialog>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<script lang="js">
import config from "@/../config";
import ViewMixin from "@/mixins/ViewMixin";
import { mask } from "vue-the-mask";
import settings from "@/app.settings";
import { formatCNPJ, formatCEP } from "@/libs/utils";

const [ADMIN, ADMIN_SUSEP, CORRETOR] = settings.niveisPerfil.map(
  (item) => item.value
);
const permissionLevels = {
  [CORRETOR]: 1,
  [ADMIN]: 2,
  [ADMIN_SUSEP]: 3,
};

export default {
  name: "MeuPerfil",
  directives: { "the-mask": mask },
  mixins: [ViewMixin],
  data: () => ({
    formatCNPJ,
    formatCEP,
    model: {
      id: "",
      id_pessoa_corretor: "",
      id_pessoa_contato: "",
      nome: "",
      email: "",
      telefone: "",
      perfil: "",
      bloqueado: "",
      corretor: {
        id: "",
        id_pessoa: "",
        cnpj_cpf: "",
        nome: "",
        telefone: "",
        email: "",
        situacao_susep: "",
        simples_nacional: null,
        cpom: null,
        endereco: {
          cep: "",
          uf: "",
          logradouro: "",
          bairro: "",
          cidade: "",
        },
        informacao_bancaria: {
          conta: "",
          agencia: "",
          banco: "",
          nome_responsavel: "",
          cpf_responsavel: "",
          email_responsavel: "",
          telefone_responsavel: "",
        },
        contatos: [],
      },
    },
    bancos: [],
    valid: [],
    loaded: false,
    userId: false,
    simplesNacionalTooltipShow: false,
    CPOMTooltipShow: false,
    activeTab: "dados-gerais",
    ADMIN,
    ADMIN_SUSEP,
    CORRETOR,
    niveisPerfis: [],
    updatePasswordModal: false,
    formErrors: [],
    emailRules: [],
    confirmDeleteModal: false,
    dialog: false,
    config,
    tabs: [
      { name: "Dados Gerais", path: "dados-gerais" },
      { name: "Dados Bancários", path: "dados-bancarios" },
      { name: "Usuários", path: "contatos" },
    ],
    selecionarEmpresaDialog: false,
    alert: true,
  }),
  computed: {
    logradouro() {
      let addressArray = [
        this.model.address[0].street,
        this.model.address[0].number,
        this.model.address[0].complement,
      ];
      let addressArrayTratado = addressArray.filter((item) => item);
      return addressArrayTratado.join(", ");
    },

    me() {
      let me = localStorage ? JSON.parse(localStorage.getItem("me")) : false;
      return me;
    },

    usedEmails() {
      let t = this;
      return t.model.corretor.contatos.map((item) => item.email);
    },

    pageName() {
      return this.$store.state.pageName;
    },

    pessoaCuritiba() {
      return this.model.corretor.endereco.cidade != null &&
        this.model.corretor.endereco.cidade.toLowerCase() !== "curitiba"
        ? true
        : false;
    },
  },

  methods: {
    insereUsuario(){
      try {
        this.model.corretor.contatos.push({
          justCreated: true,
          email: '',
        });
      } catch (e) {}finally{
        this.$forceUpdate();
        setTimeout(() => {
          this.scrollToStartAndEnd(false);
        }, 500);
      }
      this.$forceUpdate();
    },

    scrollToStartAndEnd(val){
      let elmnt = document.getElementById('scroll-top-bottom');

      elmnt.scrollIntoView({
        behavior: 'smooth',
        block: val == true ? 'start' : 'end'
      });
    },

    async getBankList() {
      try {
        this.showLoadingAskWait();
        this.bancos = await this.$store.dispatch("GET_BANK");
      } catch (e) {
        this.setErrorModal(e.response.data);
      } finally {
        this.hideLoadingAskWait();
      }
    },

    async updateContact(contato, fromContacts = false, index) {
      let t = this;
      if (!t.isFormValid(index)) return;
      if (fromContacts) {
        // t.$refs.form.validate()
        // if (!t.valid) return
      }
      let data;
      try {
        this.showLoadingIndicator();
        let payload = contato;
        payload.document = t.model.corretor.cnpj_cpf;

        if (contato.id == undefined) payload.id = contato.id_contato;
        else payload.id = contato.id;

        data = await t.$store.dispatch("UPDATE_CONTACT", payload);
      } catch (e) {
        t.errorHandler(e);
      }
      this.hideLoadingIndicator();
      if (data) {
        t.$store.commit("SET_ALERT_TEXT", {
          type: "success",
          message: "Dados alterados com sucesso!",
        });
        t.alertText = t.handleAlertText();
        t.model.corretor.contatos[
          t.model.corretor.contatos.indexOf(contato)
        ] = data;
        t.$forceUpdate();
        let me;
        try {
          me = await t.$store.dispatch("GET_ME");
        } catch (e) {
          console.warn(e);
        }
        localStorage.setItem("me", JSON.stringify(me));
      } else {
      }
    },

    async insertContact(contato, fromContacts = false, index) {
      let t = this;
      if (!t.isFormValid(index)) return;
      let data;
      try {
        this.showLoadingIndicator();
        let obj = Object.assign({}, contato);
        obj.broker_id = t.model.corretor.id;
        data = await t.$store.dispatch("INSERT_CONTACT", obj);
        this.scrollToStartAndEnd(true);
      } catch (e) {
        t.errorHandler(e);
      }
      this.hideLoadingIndicator();
      if (data) {
        t.$store.commit("SET_ALERT_TEXT", {
          type: "success",
          message: "Dados alterados com sucesso!",
        });
        t.alertText = t.handleAlertText();
        t.model.corretor.contatos[
          t.model.corretor.contatos.indexOf(contato)
        ] = data;
        t.$forceUpdate();
      }
    },

    async deleteContact(contato) {
      let t = this;

      t.confirmDeleteModal = false;
      let data;
      try {
        this.showLoadingIndicator();

        let idContato = 0;
        if (contato.id == undefined) idContato = contato.id_contato;
        else idContato = contato.id;

        data = await t.$store.dispatch("DELETE_CONTACT", idContato);
      } catch (e) {
        t.errorHandler(e);
      }
      this.hideLoadingIndicator();

      if (data) {
        t.$store.commit("SET_ALERT_TEXT", {
          type: "success",
          message: "Dados alterados com sucesso!",
        });
        t.model.corretor.contatos.splice(
          t.model.corretor.contatos.indexOf(contato),
          1
        );
        t.alertText = t.handleAlertText();
        t.$forceUpdate();
      }
    },

    async updateBankInformation(fromContacts = false) {
      var dadosBancariosForm = this.$refs.formDadosBancariosComponent;
      if (dadosBancariosForm.$refs.formDadosBancarios.validate()) {
        let t = this;
        let data;

        if (
          t.model.corretor.informacao_bancaria.banco == "" ||
          t.model.corretor.informacao_bancaria.conta == "" ||
          t.model.corretor.informacao_bancaria.agencia == ""
        ) {
          t.$store.commit("SET_ALERT_TEXT", {
            type: "warning",
            message: "Forneça todos os dados bancários",
          });
          t.alertText = t.handleAlertText();
          return;
        }

        try {
          console.log( t.model);
          this.showLoadingIndicator();
          data = await t.$store.dispatch("UPDATE_BANK_INFORMATION", t.model);
        } catch (error) {
          this.defaultHandlerError(error);
        } finally {
          this.hideLoadingIndicator();
        }

        if (data) {
          t.$store.commit("SET_ALERT_TEXT", {
            type: "success",
            message: "Dados alterados com sucesso!",
          });
          t.alertText = t.handleAlertText();

          t.$forceUpdate();
        }
      } else this.$forceUpdate();
    },

    async toggleBlocked(user, $event) {
      let t = this;
      let me = localStorage ? JSON.parse(localStorage.getItem("me")) : false;

      let response;
      let email = user.email;
      let companyId = me.company_id;
      t.showLoadingIndicator();
      try {
        response = await t.$store.dispatch("TOGGLE_BLOCKED_CONTACT", {
          email,
          companyId,
        });
      } catch (e) {
        t.hideLoadingIndicator();
        // revert
        user.blocked = !user.blocked;
        return;
      }
      t.hideLoadingIndicator();

      t.$forceUpdate();
    },

    async getMe(fromNeurotech = false) {
      let t = this;
      let myDocument = t.model.corretor.cnpj_cpf;
      t.showLoadingIndicator();
      let response1;

      try {
        t.model = await t.$store.dispatch("GET_PROFILE_ME", {
          document: myDocument,
          fromNeurotech,
        });
      } catch (e) {
        console.warn(e);
      }

      t.userId = t.model.id;
      t.model.nome = t.model.nome.trim();

      document.title += " - " + t.model.nome;
      if (
        !t.model.corretor.informacao_bancaria ||
        !t.model.corretor.informacao_bancaria.banco
      ) {
        t.model.corretor.informacao_bancaria = {
          banco: "",
          agencia: "",
          conta: "",
          nome_responsavel: "",
          cpf_responsavel: "",
          email_responsavel: "",
          telefone_responsavel: "",
        };
      } else {
        t.model.corretor.informacao_bancaria.banco = t.model.corretor.informacao_bancaria.banco.padStart(
          3,
          "0"
        );
      }
      t.niveisPerfis = t.$settings.niveisPerfil;
      t.hideLoadingIndicator();
      t.loaded = true;
      t.$forceUpdate();
    },

    async updateProfile(fromContacts = false) {
      let t = this;
      if (fromContacts) {
        t.$refs.form.validate();
        if (!t.valid) return;
      }
      let data;

      try {
        this.showLoadingIndicator();
        t.model.corretor.informacao_bancaria.conta =
          "" + t.model.corretor.informacao_bancaria.conta;
        t.model.corretor.informacao_bancaria.agencia =
          "" + t.model.corretor.informacao_bancaria.agencia;

        let obj = t.model;
        let informacao_bancaria = obj.corretor.informacao_bancaria;
        if (
          !informacao_bancaria.banco &&
          !informacao_bancaria.conta &&
          informacao_bancaria.agencia
        ) {
          delete obj.informacao_bancaria;
        }
        data = await t.$store.dispatch("COMPLETE_REGISTRATION", t.model);
      } catch (e) {
        t.errorHandler(e);
      }
      this.hideLoadingIndicator();
      if (data) {
        t.$store.commit("SET_ALERT_TEXT", {
          type: "success",
          message: "Dados alterados com sucesso!",
        });
        t.alertText = t.handleAlertText();
        t.model.corretor.contatos = data.contatos;
        t.$forceUpdate();
      }
    },

    checkIfIsAdmin(contact) {
      return [ADMIN, ADMIN_SUSEP].includes(this.model.perfil);
    },

    checkPermissionBiggerThan(modelProfile, contactProfile) {
      let modelPermission = permissionLevels[modelProfile];
      let contactPermission = permissionLevels[contactProfile];
      return modelPermission > contactPermission;
    },

    checkPermissionEqualsOrBiggerThan(
      modelProfile,
      contactProfile,
      nomeOrTelefone = false,
      isMyself = false
    ) {
      if (nomeOrTelefone && modelProfile === "CORRETOR" && isMyself) {
        return true;
      }
      if (modelProfile === "CORRETOR") return false;
      let modelPermission = permissionLevels[modelProfile];
      let contactPermission = permissionLevels[contactProfile];
      return modelPermission >= contactPermission;
    },

    hasPermission(field, contato) {
      if (this.model.perfil === "ADMIN_SUSEP") {
        if (contato.perfil === "ADMIN_SUSEP") {
          if (
            field === "perfil" ||
            field === "bloqueado" ||
            field === "remover"
          ) {
            return false;
          }
        }
        return true;
      } else {
        if (contato.perfil === "ADMIN_SUSEP") {
          return false;
        }
        if (this.model.perfil === "CORRETOR") {
          return false;
        }
      }
      return true;
    },

    toggleTooltip(tooltipToActivate) {
      let t = this;

      if (tooltipToActivate === "CPOM") {
        t.CPOMTooltipShow = !t.CPOMTooltipShow;
        t.simplesNacionalTooltipShow = false;
      }
      if (tooltipToActivate === "simplesNacional") {
        t.simplesNacionalTooltipShow = !t.simplesNacionalTooltipShow;
        t.CPOMTooltipShow = false;
      }
    },

    isFormValid(index) {
      let t = this;
      let refsIndex = "form" + index;
      t.$refs[refsIndex][0].validate();
      return t.valid[index];
    },

    removeContactOnlyFromClient(contato) {
      let t = this;
      t.model.corretor.contatos.splice(
        t.model.corretor.contatos.indexOf(contato),
        1
      );
      t.$forceUpdate();
    },

    numberOrSlash(evt) {
      evt = evt ? evt : window.event;
      if (!evt.key.match(/[\d\-]/)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    getGrupos() {},
    successHandler(message, response) {
      let t = this;
      t.$store.commit("SET_ALERT_TEXT", { type: "success", message });
      t.$router.push("/corretores/");
    },

    errorHandler(error) {
      let t = this;
      t.formErrors = error.data;
      t.$forceUpdate();
    },
  },
  mounted() {
    let t = this;
    t.simplesNacionalTooltipText = t.$strings.simplesNacionalTooltipText;
    t.CPOMTooltipText = t.$strings.CPOMTooltipText;
    t.getBankList();

    let fromNeurotech = false;

    t.getMe(fromNeurotech);
  },
};
</script>

<style lang="scss" scoped>
#jns {
  #container {
    height: auto;
  }

  .contact-row {
    width: 100%;
    padding: 20px;
  }

  .form-contato {
    display: flex;
    width: 100%;

    .primeira-row,
    .segunda-row {
      display: flex;
      width: 100%;

      .v-input {
        width: 30% !important;
        margin-right: 2% !important;
      }

      .margin-none {
        margin-right: 0 !important;
      }

      .box-select-perfil {
        display: flex;
        width: 40%;
        margin-right: 2%;
      }

      .box-actions {
        display: flex;
        justify-content: space-between;
        width: 60%;

        .box-switch {
          display: flex;
          flex-direction: column;
          width: 40%;
        }

        .box-buttons {
          display: flex;
          justify-content: flex-end;
          flex: 1;

          .box-button {
            width: 50% !important;
            margin-right: 2% !important;
          }
        }
      }
    }
  }

  @media screen and (max-width: 970px) {
    .form-contato {
      flex-wrap: wrap;

      .primeira-row,
      .segunda-row {
        flex-direction: column;

        .v-input {
          width: 100% !important;
          margin: 2% 0 2.5% 0 !important;
        }

        .box-select-perfil {
          width: 100%;
          margin: 0 0 0 0;
          text-overflow: ellipsis;
        }

        .box-actions {
          width: 100%;

          .box-switch {
            display: flex;
            flex-direction: column;
            width: 30%;
          }

          .box-buttons {
            width: 70%;

            .box-button {
              width: 100%;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 490px) {
    .form-contato {
      .primeira-row,
      .segunda-row {
        .box-actions {
          width: 100%;
          flex-wrap: wrap;

          .box-switch {
            display: flex;
            flex-direction: column;
            width: 100%;
          }

          .box-buttons {
            width: 100%;
            flex-direction: column;
            .box-button {
              width: 100% !important;
            }
          }
        }
      }
    }
  }

  .box-button-add {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-start;

    .jns-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40%;

      span {
        margin: 3px 0 0 5px;
      }
    }
  }

  @media screen and (max-width: 865px) {
    .box-button-add {
      justify-content: center;

      .jns-button {
        width: 95%;
      }
    }
  }

  @media screen and (max-width: 470px) {
    .box-button-add {
      .jns-button {
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 0.875rem;
      }
    }
  }

  .contact-row {
    border-bottom: 1px solid #eee;
  }
  .switch-label {
    margin-top: -6px;
    display: inherit;
    font-size: 12px;
    color: #061d45;
    font-weight: bold;
  }
  .block-switch {
    margin-top: 10px;
  }
  .info-icon {
    color: #282498;
    cursor: pointer;
    margin-top: -5px;
    margin-left: 5px;
  }
  .tos-text-field {
    height: 570px;
    max-height: auto;
  }
  .delete-contact {
    i {
      display: inline-block;
      font-size: 32px;
      margin-top: 24px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .add-new-contact {
    font-size: 14px;
    color: #282498;
    font-weight: bold;
    text-decoration: none;
    margin-top: 3px;
    display: inline-block;
    i {
      color: #282498;
      margin-top: -3px;
    }
  }
}

.no-padding-top {
  padding-top: 0 !important;
}
.form-card {
  .layout {
    margin: 0 !important;
    &.no-padding {
      padding: 0;
    }

    padding: 4px;
  }

  .v-card__title {
    background-color: #efefef;
    font-size: 16px;
    font-weight: bolder;
    color: #191737;
    margin-bottom: 20px;
  }

  .dropbox {
    outline: 2px dashed #c2c2c2; /* the dash box */
    outline-offset: -10px;
    color: dimgray;
    padding: 10px 10px;
    min-height: 85px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: #eee; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
    color: #a5a5a5;
    font-size: 14px;
    font-weight: bold;
  }
  .radio-label {
    color: #555;
  }
  .full-width {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Perfis/Eu.vue